// hooks/useJournal.ts
import { format } from "date-fns";
import { useState, useCallback, useEffect } from "react";
import { JournalEntry } from "../types/journal";
import { journalAPI } from "../lib/api/journal";


export function useJournal() {
  const [entries, setEntries] = useState<JournalEntry[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<any | null>(null);
  const [analysis, setAnalysis] = useState<any | null>(null);

  const fetchEntries = useCallback(async (startDate: Date) => {
    setIsLoading(true);
    setError(null);
    try {

      const fetchedEntries = await journalAPI.getEntries(startDate);
   
      setEntries(fetchedEntries);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Failed to fetch entries");
    } finally {
      setIsLoading(false);
    }
  }, []);



  const fetchAnalysis = useCallback(async (date: Date) => {
    try {
      const data = await journalAPI.getAnalysisByDate(new Date(date));
      if(data?.error){
        setError(data.error);
        return
      }
      setAnalysis(data);
    } catch (error) {
      setError(error)
      console.error("Error fetching data:", error);
    }
  }, []);


  const createEntry = useCallback(
    async (data: {
      date: Date;
      type: "morning" | "evening";
      content: string;
      metrics: Record<string, number>;
    }) => {
      setError(null);
      try {
        const newEntry = await journalAPI.createEntry(data);
        setEntries((prev) => [...prev, newEntry]);
        return newEntry;
      } catch (err) {
        setError(err instanceof Error ? err.message : "Failed to create entry");
        throw err;
      }
    },
    []
  );

  const updateEntry = useCallback(
    async (data: {
      date: Date;
      type: "morning" | "evening";
      content: string;
      metrics: Record<string, number>;
    }) => {
      setError(null);
      try {
        const updatedEntry = await journalAPI.updateEntry(data);
        setEntries((prev) =>
          prev.map((entry) =>
            format(entry.date, "yyyy-MM-dd") ===
              format(data.date, "yyyy-MM-dd") && entry.type === data.type
              ? updatedEntry
              : entry
          )
        );
        return updatedEntry;
      } catch (err) {
        setError(err instanceof Error ? err.message : "Failed to update entry");
        throw err;
      }
    },
    []
  );

  return {
    entries,
    isLoading,
    error,
    fetchEntries,
    fetchAnalysis,
    analysis,
    createEntry,
    updateEntry,
  };
}
